import * as ActionTypes from "./types";

// Fetch support tickets list
export function fetchTickets(payload) {
  return {
    type: ActionTypes.FETCH_TICKETS,
    payload,
  };
}

export function storeTickets(payload) {
  return {
    type: ActionTypes.STORE_TICKETS,
    payload,
  };
}

export function fetchTicketsFailed(payload) {
  return {
    type: ActionTypes.FETCH_TICKETS_FAILED,
    payload,
  };
}

// Fetch single support ticket
export function fetchTicketId(payload) {
  return {
    type: ActionTypes.FETCH_TICKET_ID,
    payload,
  };
}

export function storeTicketId(payload) {
  return {
    type: ActionTypes.STORE_TICKET_ID,
    payload,
  };
}

export function fetchTicketIdFailed(payload) {
  return {
    type: ActionTypes.FETCH_TICKET_ID_FAILED,
    payload,
  };
}

// Create support ticket
export function createTicket(payload) {
  return {
    type: ActionTypes.CREATE_TICKET,
    payload,
  };
}

export function createTicketSucceed(payload) {
  return {
    type: ActionTypes.CREATE_TICKET_SUCCEED,
    payload,
  };
}

export function createTicketFailed(payload) {
  return {
    type: ActionTypes.CREATE_TICKET_FAILED,
    payload,
  };
}

// Update support ticket
export function updateTicket(payload) {
  return {
    type: ActionTypes.UPDATE_TICKET,
    payload,
  };
}

export function updateTicketSucceed(payload) {
  return {
    type: ActionTypes.UPDATE_TICKET_SUCCEED,
    payload,
  };
}

export function updateTicketFailed(payload) {
  return {
    type: ActionTypes.UPDATE_TICKET_FAILED,
    payload,
  };
}

// Form management
export function updateTicketFormField(payload) {
  return {
    type: ActionTypes.UPDATE_TICKET_FORM_FIELD,
    payload,
  };
}

export function clearTicketForm(payload) {
  return {
    type: ActionTypes.CLEAR_TICKET_FORM,
    payload,
  };
}
